import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import {useCMS} from '../context/CMSContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiArrowRight,FiCheckCircle,FiShield,FiTrendingUp}=FiIcons;

const Home=()=> {
  const {content}=useCMS();
  const {hero,services,testimonials,company}=content;

  const containerVariants={
    hidden: {opacity: 0},
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants={
    hidden: {opacity: 0,y: 20},
    visible: {
      opacity: 1,
      y: 0,
      transition: {duration: 0.8,ease: 'easeOut',},
    },
  };

  return ( 
    <div className="min-h-screen"> 
      <section className="relative text-white pb-16 lg:pb-32 overflow-hidden min-h-screen flex items-center" style={{marginTop: '-96px',paddingTop: '96px'}} > 
        <div className="absolute inset-0 w-full h-full overflow-hidden z-0"> 
          <img src="https://images.pexels.com/photos/4231781/pexels-photo-4231781.jpeg?auto=compress&cs=tinysrgb&w=1600&h=900&fit=crop&brightness=1.1&contrast=1.05" alt="Eau pure et environnement" className="w-full h-full object-cover" /> 
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div> 
        </div> 
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full"> 
          <motion.div initial={{opacity: 0,y: 50}} animate={{opacity: 1,y: 0}} transition={{duration: 0.8}} className="max-w-3xl" > 
            <div className="inline-block bg-gold-500/90 text-gray-900 px-3 sm:px-4 py-1 rounded-full text-xs sm:text-sm font-semibold mb-4 sm:mb-6 backdrop-blur-sm"> 
              Leader QHSE en zone CEMAC 
            </div> 
            <h1 className="text-3xl sm:text-4xl lg:text-6xl xl:text-7xl font-bold mb-4 sm:mb-6 leading-tight"> 
              Excellence en{' '} 
              <span className="bg-gradient-to-r from-yellow-300 via-yellow-200 to-yellow-400 bg-clip-text text-transparent"> 
                QHSE 
              </span>{' '} 
              pour votre performance durable 
            </h1> 
            <p className="text-base sm:text-lg lg:text-xl mb-6 sm:mb-10 text-gray-200 leading-relaxed max-w-2xl"> 
              {hero.description} 
            </p> 
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4"> 
              <Link to="/contact" className="bg-gradient-to-r from-gold-500 to-yellow-400 hover:from-gold-600 hover:to-yellow-500 text-gray-900 px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold text-sm sm:text-base lg:text-lg transition-all transform hover:scale-105 shadow-lg flex items-center justify-center" > 
                {hero.primaryCTA} 
                <SafeIcon icon={FiArrowRight} className="ml-2 w-4 h-4" /> 
              </Link> 
              <Link to="/services" className="bg-gradient-to-r from-white/20 to-white/10 hover:from-white/30 hover:to-white/20 backdrop-blur-md text-white border border-white/30 px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold text-sm sm:text-base lg:text-lg transition-all flex items-center justify-center" > 
                {hero.secondaryCTA} 
              </Link> 
            </div> 
          </motion.div> 
        </div> 
        <motion.div className="absolute bottom-8 sm:bottom-10 left-1/2 transform -translate-x-1/2 text-white/70" animate={{y: [0,10,0]}} transition={{repeat: Infinity,duration: 1.5}} > 
          <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center p-1"> 
            <div className="w-1 h-2 bg-white rounded-full"></div> 
          </div> 
        </motion.div> 
      </section> 
      <section className="py-12 sm:py-16 lg:py-20 bg-white"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center"> 
            <motion.div initial={{opacity: 0,x: -50}} whileInView={{opacity: 1,x: 0}} viewport={{once: true}} > 
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 sm:mb-6 bg-gradient-to-r from-gold-600 to-gold-500 bg-clip-text text-transparent"> 
                Votre partenaire de confiance pour la conformité et la performance 
              </h2> 
              <p className="text-sm sm:text-base lg:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed"> 
                {company.mission} 
              </p> 
              <ul className="space-y-2 sm:space-y-4 mb-6 sm:mb-8"> 
                {[ 
                  'Accompagnement certification ISO (9001,14001,45001)',"Solutions complètes d'assainissement et biogaz","Laboratoire d'analyse environnementale agréé",'Formation et développement des compétences',
                ].map((item,index)=> ( 
                  <li key={index} className="flex items-start text-gray-700 text-sm sm:text-base"> 
                    <SafeIcon icon={FiCheckCircle} className="w-5 h-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" /> 
                    {item} 
                  </li> 
                ))} 
              </ul> 
              <Link to="/about" className="text-gold-500 font-semibold hover:text-gold-600 flex items-center group text-sm sm:text-base" > 
                En savoir plus sur nous 
                <SafeIcon icon={FiArrowRight} className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" /> 
              </Link> 
            </motion.div> 
            <motion.div initial={{opacity: 0,x: 50}} whileInView={{opacity: 1,x: 0}} viewport={{once: true}} className="relative" > 
              <div className="relative rounded-2xl overflow-hidden shadow-2xl"> 
                <img src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&q=80&w=800" alt="Ingénieurs QHSE au travail" className="w-full h-full object-cover" /> 
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6 sm:p-8"> 
                  <div className="text-white"> 
                    <div className="text-2xl sm:text-3xl font-bold mb-1">8+</div> 
                    <div className="text-white/80 text-sm sm:text-base">Années d'expérience</div> 
                  </div> 
                </div> 
              </div> 
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-yellow-100 rounded-full mix-blend-multiply filter blur-xl opacity-70"></div> 
              <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-yellow-100 rounded-full mix-blend-multiply filter blur-xl opacity-70"></div> 
            </motion.div> 
          </div> 
        </div> 
      </section> 
      <section className="py-12 sm:py-16 lg:py-20 bg-gray-50"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12 sm:mb-16"> 
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 bg-gradient-to-r from-gold-600 to-gold-500 bg-clip-text text-transparent"> 
              Nos Domaines d'Expertise 
            </h2> 
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-2xl mx-auto"> 
              {services.subtitle} 
            </p> 
          </div> 
          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{once: true}} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" > 
            {services.items.slice(0,3).map((service)=> ( 
              <motion.div key={service.id} variants={itemVariants}> 
                <Link to={`/services/${service.id}`} className="block h-full"> 
                  <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-2xl transition-all h-full border border-gray-100 group"> 
                    <div className={`w-16 h-16 ${service.color} rounded-2xl flex items-center justify-center mb-6 text-white text-2xl group-hover:scale-110 transition-transform`} > 
                      <SafeIcon icon={FiIcons[service.icon]} /> 
                    </div> 
                    <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 mb-4 group-hover:text-gold-500 transition-colors"> 
                      {service.title} 
                    </h3> 
                    <p className="text-sm sm:text-base text-gray-600 mb-6 line-clamp-3"> 
                      {service.description} 
                    </p> 
                    <div className="flex items-center text-gold-500 font-semibold text-sm sm:text-base"> 
                      Découvrir 
                      <SafeIcon icon={FiArrowRight} className="ml-2 w-4 h-4 group-hover:translate-x-2 transition-transform" /> 
                    </div> 
                  </div> 
                </Link> 
              </motion.div> 
            ))} 
          </motion.div> 
          <div className="text-center mt-12"> 
            <Link to="/services" className="inline-flex items-center bg-gradient-to-r from-pink-600 to-pink-500 text-white px-6 sm:px-8 py-3 rounded-xl font-semibold hover:shadow-lg transition-all text-sm sm:text-base" > 
              Voir tous nos services 
            </Link> 
          </div> 
        </div> 
      </section> 
      <section className="py-12 sm:py-16 lg:py-20 bg-white overflow-hidden"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12 sm:mb-16"> 
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4"> 
              Ce que disent nos partenaires 
            </h2> 
          </div> 
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8"> 
            {testimonials.items.slice(0,2).map((item)=> ( 
              <motion.div key={item.id} initial={{opacity: 0,y: 30}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} className="bg-gray-50 p-6 sm:p-8 rounded-2xl relative" > 
                <div className="text-5xl sm:text-6xl text-yellow-200 absolute top-4 left-4 font-serif"> 
                  " 
                </div> 
                <p className="text-gray-700 text-base sm:text-lg italic mb-6 relative z-10"> 
                  {item.text} 
                </p> 
                <div className="flex items-center"> 
                  <div className="w-12 h-12 bg-gray-300 rounded-full flex items-center justify-center text-gray-600 font-bold text-xl mr-4 flex-shrink-0"> 
                    {item.name.charAt(0)} 
                  </div> 
                  <div> 
                    <h4 className="font-bold text-gray-900 text-sm sm:text-base">{item.name}</h4> 
                    <p className="text-xs sm:text-sm text-gray-500">{item.company}</p> 
                  </div> 
                </div> 
              </motion.div> 
            ))} 
          </div> 
        </div> 
      </section> 
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-slate-900 to-slate-800 text-white text-center"> 
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold mb-6 sm:mb-8"> 
            Prêt à élever vos standards QHSE ? 
          </h2> 
          <p className="text-base sm:text-lg lg:text-xl text-slate-300 mb-8 sm:mb-10"> 
            Contactez-nous dès aujourd'hui pour une évaluation gratuite de vos besoins. 
          </p> 
          <Link to="/contact" className="inline-block bg-gradient-to-r from-gold-500 to-yellow-400 hover:from-gold-600 hover:to-yellow-500 text-gray-900 px-6 sm:px-10 py-4 sm:py-5 rounded-xl font-bold text-base sm:text-lg lg:text-xl shadow-lg hover:shadow-yellow-500/30 transition-all" > 
            Demander un devis gratuit 
          </Link> 
        </div> 
      </section> 
    </div> 
  );
};

export default Home;